import React from 'react';

import { type TBlock } from '@wp-block-builder/package';

import LoopRunner from './LoopRunner';

type Props = {
  block: Extract<TBlock, { type: 'LoopContainer' }>;
  BlockComponent: (props: { block: TBlock }) => JSX.Element;
};
export function LoopContainerBlock({ block, BlockComponent }: Props) {
  const { loopTemplate, loopArgumentName, loopIndexName } = block.props || {};
  const blocks = block.props?.blocks ?? [];
  return (
    <LoopRunner
      placeholder={null}
      loopTemplate={loopTemplate}
      loopArgumentName={loopArgumentName}
      loopIndexName={loopIndexName}
      renderLoopIteration={() => (
        <>
          {blocks.map((block, i) => (
            <BlockComponent key={i} block={block} />
          ))}
        </>
      )}
    />
  );
}
